

import React from "react";
import {
  FaLeaf,
  FaOilCan,
  FaSeedling,
} from "react-icons/fa";

import coconut from "../assests/coconut.png.jpeg";
import tender from "../assests/tenderc.png";
import copra from "../assests/ccopora.png";
import oil from "../assests/coil.png";
import leaf from "../assests/cleaves1.jpg";
import shell from "../assests/cshell.png";

const products = [
  {
    title: "Fresh Coconuts",
    image: coconut,
    icon: <FaSeedling />,
    description:
      "Naturally grown premium quality coconuts harvested directly from our farms.",
  },
  {
    title: "Tender Coconuts",
    image: tender,
    icon: <FaSeedling />,
    description:
      "Fresh tender coconuts rich in natural electrolytes and refreshing coconut water.",
  },
  {
    title: "Copra",
    image: copra,
    icon: <FaLeaf />,
    description:
      "Premium dried coconut kernels suitable for oil extraction and food processing.",
  },
  {
    title: "Coconut Oil",
    image: oil,
    icon: <FaOilCan />,
    description:
      "Pure and natural coconut oil extracted using hygienic processing methods.",
  },
  {
    title: "Coconut Leaves",
    image: leaf,
    icon: <FaLeaf />,
    description:
      "Fresh and dried coconut leaves for decoration, roofing and handicrafts.",
  },
  {
    title: "Coconut Shell",
    image: shell,
    icon: <FaSeedling />,
    description:
      "Durable coconut shells ideal for charcoal, crafts and activated carbon.",
  },
];

function Products() {
  return (
    <section
      id="products"
      className="py-16 md:py-20 lg:py-24 bg-gradient-to-b from-green-50 to-white"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">

        {/* Heading */}

        <div className="text-center mb-12 lg:mb-16">

          <p className="text-green-700 font-semibold uppercase tracking-[4px] text-sm md:text-base">
            Our Products
          </p>

          <h2 className="mt-4 font-bold text-gray-800 text-3xl sm:text-4xl lg:text-5xl leading-tight">
            Premium <span className="text-green-700">Coconut Products</span>
          </h2>

          <p className="mt-5 max-w-3xl mx-auto text-gray-600 text-base md:text-lg leading-8 px-2">
            We provide a wide range of premium coconut products sourced
            directly from our farms with guaranteed freshness,
            purity and superior quality.
          </p>

          <div className="w-24 h-1 bg-green-700 rounded-full mx-auto mt-6"></div>

        </div>

        {/* Products */}

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-8">

          {products.map((product, index) => (

            <div
              key={index}
              className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 group"
            >

              <div className="overflow-hidden">

                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-56 sm:h-64 lg:h-72 object-cover group-hover:scale-110 transition duration-700"
                />

              </div>

              <div className="relative p-6 lg:p-7">

                <div className="absolute -top-7 left-6 w-14 h-14 rounded-full bg-green-700 text-white flex items-center justify-center text-xl shadow-lg">

                  {product.icon}

                </div>

                <h3 className="mt-8 text-xl lg:text-2xl font-bold text-gray-800">

                  {product.title}

                </h3>

                <p className="mt-4 text-gray-600 leading-7 text-sm md:text-base">

                  {product.description}

                </p>

              </div>

            </div>

          ))}

        </div>

        {/* Features */}

        <div className="mt-16 lg:mt-20 bg-green-800 rounded-3xl py-8 lg:py-10 px-5 lg:px-8">

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 text-white">

            <div className="text-center">

              <div className="text-4xl mb-3">🌴</div>

              <h3 className="font-semibold text-lg">
                Farm Fresh
              </h3>

            </div>

            <div className="text-center">

              <div className="text-4xl mb-3">🌿</div>

              <h3 className="font-semibold text-lg">
                100% Natural
              </h3>

            </div>

            <div className="text-center">

              <div className="text-4xl mb-3">⭐</div>

              <h3 className="font-semibold text-lg">
                Premium Quality
              </h3>

            </div>

            <div className="text-center">

              <div className="text-4xl mb-3">♻️</div>

              <h3 className="font-semibold text-lg">
                Eco Friendly
              </h3>

            </div>

            <div className="text-center col-span-2 md:col-span-1">

              <div className="text-4xl mb-3">🚚</div>

              <h3 className="font-semibold text-lg">
                Worldwide Delivery
              </h3>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
}

export default Products;